import { render } from "./PortfolioDetailView.vue?vue&type=template&id=f193cd08"
import script from "./PortfolioDetailView.vue?vue&type=script&lang=js"
export * from "./PortfolioDetailView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\compro.rimba.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__